import { RouterModule, Routes } from '@angular/router'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { OrgComponent } from './org.component'
import { SharedModule } from '../shared/shared.module'
import { EventCardComponent } from './event-card/event-card.component'
import { HomeComponent } from './home/home.component'

const routes: Routes = [
  {
    path: '',
    component: OrgComponent,
    children: [
      {
        path: '',
        component: HomeComponent
      },
      {
        path: ':event',
        loadChildren: () =>
          import('../event/event.module').then((m) => m.EventModule)
      }
    ]
  }
]

@NgModule({
  declarations: [OrgComponent, EventCardComponent, HomeComponent],
  imports: [CommonModule, RouterModule.forChild(routes), SharedModule]
})
export class OrgModule {}
